// src/pages/chat/fullscreen-recording-dock/fullscreen-recording-dock.hooks.ts
import { useCallback } from "react";
import type { CtaHandle } from "../CTA/cta";

type Args = {
    ctaRef: React.RefObject<CtaHandle | null>;
};

export const useRecordingControls = ({ ctaRef }: Args) => {
    const pause = useCallback(() => {
        ctaRef.current?.pause();
    }, [ctaRef]);

    const resume = useCallback(() => {
        ctaRef.current?.resume();
    }, [ctaRef]);

    const stop = useCallback(() => {
        ctaRef.current?.stop();
    }, [ctaRef]);

    const cancel = useCallback(() => {
        ctaRef.current?.cancel();
    }, [ctaRef]);

    const reRecord = useCallback(() => {
        // ✅ discard + immediately restart recording without leaving fullscreen
        ctaRef.current?.reRecord();
    }, [ctaRef]);

    return {
        pause,
        resume,
        stop,
        cancel,
        reRecord,
    };
};
